import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import type { ButtonSize, ButtonVariant } from './Button';
import './Button.css';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required: an icon button has no visible text. */
  label: string;
  icon: ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, variant = 'ghost', size = 'md', className, ...rest },
  ref,
) {
  const classes = [
    'pui-button',
    'pui-icon-button',
    `pui-button--${variant}`,
    `pui-button--${size}`,
    `pui-icon-button--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button ref={ref} type="button" className={classes} aria-label={label} title={label} {...rest}>
      <span className="pui-button__icon" aria-hidden="true">
        {icon}
      </span>
    </button>
  );
});
